import { useState } from "react";
import { siteFaqs } from "@/mocks/site";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto grid w-full grid-cols-1 gap-10 px-4 py-14 md:px-8 md:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:gap-16">
        <div className="lg:sticky lg:top-28 lg:self-start">
          <span className="text-xs tracking-[0.2em] text-primary-600">FAQ</span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">大家最常问的几件事</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            如果这里没有你要的答案，直接去联系页面留言，我们尽量当天回复。
          </p>
        </div>

        <div className="divide-y divide-background-200 border-y border-background-200">
          {siteFaqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <article key={faq.q}>
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIndex(isOpen ? null : index)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left"
                  >
                    <span className="font-heading text-base text-foreground-950 md:text-lg">{faq.q}</span>
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-background-100 text-foreground-700"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line text-base" : "ri-add-line text-base"}></i>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">{faq.a}</p>
                )}
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}